import getConfig from 'next/config';

export const isEnvProduction = () =>
  typeof window !== 'undefined'
    ? getConfig().publicRuntimeConfig.environment === 'production'
    : process.env.ENV === 'production';
